export default {
    computed: {
        cardsToInsert() {
            return this.slice.items
                .filter(item => item.card?.id)
                .filter(item => !Number.isNaN(parseInt(item.at_position)))
                .filter(item => !item.until || Date.now() <= new Date(item.until))
                .sort((a, b) => parseInt(a.at_position) - parseInt(b.at_position));
        }
    },
    methods: {
        insertCardsAtPositions(cards) {
            const cardList = [...cards];

            this.cardsToInsert.forEach(item => {
                const index = cardList.findIndex(card => card.id === item.card.id);
                if (index === -1) {
                    return;
                }

                cardList.splice(index, 1);
                cardList.splice(parseInt(item.at_position) - 1, 0, item.card);
            });

            return cardList;
        }
    }
};
